import { inject, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { merge, Subscription } from 'rxjs';
import { FormUtilsService } from './form-utils.service';

@Pipe({
  name: 'validationError',
  standalone: true,
  pure: false,
})
export class ValidationErrorPipe implements PipeTransform, OnDestroy {
  #formUtils = inject(FormUtilsService);
  sub: Subscription | null = null;

  transform(
    errors: ValidationErrors | null | undefined,
    interpolateParams?: Record<string, string | number>,
    customErrors: Record<string, string> = {},
  ): string {
    if (!errors) {
      return '';
    }

    this.sub?.unsubscribe();
    const messages = Object.entries(errors).map(([key, value]) => {
      if (!interpolateParams && value instanceof Object) {
        interpolateParams = value;
      }

      return this.#formUtils.getErrorMessage(key, interpolateParams, customErrors);
    });

    const result: string[] = [];
    this.sub = merge(...messages).subscribe((message) => {
      result.push(message);
    });

    return result.join('. ');
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
    this.sub = null;
  }
}
